import React, { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Select, MenuItem, FormControlLabel, Tooltip } from '@material-ui/core';
import { ExpandMore, ArrowBack } from '@material-ui/icons';
import c from 'classnames';
import { Helmet } from 'react-helmet';

import { cloneDeep } from 'lodash';
import AuthStore from '../../../common/AuthStore';
import FilterBar from '../../../components/FilterBar';
import FilterSvg from '../assets/Filter.svg';
import ActiveFilters1 from '../assets/ActiveFilters1.svg';
import Down from '../assets/Down.svg';
import CompareView from '../assets/CompareView.svg';
import comparisonBu from '../assets/comparisonBu.svg';
import BulletList from '../assets/BulletList.svg';
import colors from '../../../sass/colors';
import { getStaticText } from '../../../utils/constants';
import {
    addZeroToNUmber,
    sortArray,
    getBenchmarkName,
    getBenchmarkString,
    updateFilterParams,
    getPptValues,
    getFilterArray,
    clearDemographicSelections,
    resolveEntireOrganizationComparisonLabel,
} from '../../../utils/functions';
import './index.scss';
import ErrorToast from '../../../components/InformationToast/ErrorToast';
import DwnldModal from '../../../components/InformationToast/DwnldModal';
import SelectModal from '../../../components/SelectModal';
import PracticeBuBoard from './PracticeBuBoard';
import ResurveyBoard from './ResurveyBoard';
import getStaticTextDiagnose from '../constants';
import { getBuComparisonLabel } from '../IndExperienceBoard/indExperiencePublicSector';

function PracticeBoard({
    practiceData,
    practiceDataFetched,
    getPracticeData,
    toggleFilterView,
    apiParams,
    apiLoadingCount,
    activeFilter,
    errorInfo,
    filters,
    getPptData,
    practiceToDisplay,
    setPracticeDisplay,
    defaultSettings,
    scoreData,
    scoreDataFetched,
    getScoreData,
    practiceFilters,
    isEntireOrganizationSelected,
    updateEntireOrganizationComparison,
    getPracticeBuData,
    practiceBuData,
    practiceBuDataFetched,
    updateFilters,
    updatePracticeBuFilters,
    resetPracticeBuDataFetched,
    appliedFiltersInfo,
    getReport,
    getRawPptData,
    reportError,
    getSinglePastReport,
    singlePastReport,
    practiceDataCompYr,
    getComparisonYrPracticeData,
    projects,
    projectsFetched,
    getBuData,
    buData,
    buDataFetched,
    getDemographics,
    getBenchmarks,
    getPracticeResurveyData,
    practiceResurveyData,
    getReSurveyData,
    reSurveyData,
    reSurveyDataFetched,
    resetReSurveyDataFetched,
    reportsData,
    getReports,
    reportsDataFetched,
}) {
    const { $white } = colors;
    const {
        benchmark = [],
        report_name_or_client_name: rName = '',
        report_name = '',
        lang,
        quartileColors = [],
        survey_version = '',
        report_id = '',
        checkme_mapping = {},
        demographic = '',
        ohid: currentOhid = '',
        resurvey_settings = '',
        report_type: surveyType = '',
        resurvey_custom_delta = '',
        engagement,
        is_public_sector_ohi = false,
    } = defaultSettings;
    const staticTextDiagnose = getStaticTextDiagnose(lang);
    const { QUARTILE_RESURVEY } = staticTextDiagnose;
    const staticText = getStaticText(lang);
    const {
        SITE_TEXT,
        BPP_LIST,
        SINGLE_PAGE_EXPORT_PARAMS,
        RESURVEY_EXPORT_PARAMS,
        ING_REPORT_ID,
        NON_PROFIT_SURVEY,
    } = staticText;
    const isOhi4 = survey_version === '4' || survey_version === '3_2';
    const {
        PRACTICE_HEAD,
        FILTERS,
        TORNADO_LABEL,
        VS_LABEL,
        LEGEND,
        COMPARE_TO_RECIPE,
        RECIPE_TOP,
        UNDER_EMPHASIZED,
        HIGH_PRACTICES,
        DOWNLOAD,
        BU_HEAD,
        COMPARE_BU,
        BU_PROJECTS,
        SOURCE_TEXT,
        BENCHMARK_HEAD,
        NUMBER_TEXT,
        NUMBER_SURVEY_TEXT,
        ALL_PPT_TEXT,
        PPT_VALUES,
        NOTE,
        PRACTICE_RANKING_NOTE,
        RESURVEY_TEXT,
        HEALTH_PRACTICE_RANKING,
        BU_COMPARISION,
        NUMBER_OF_RESPONDENTS_N,
        SHOW_SCORES,
        TOP_RANKING,
        MIDDLE_RANKING,
        BOTTOM_RANKING,
        RANK,
        PRACTICES,
        PERCENT_FAVORABLE,
        PERCENTILES,
        COMPARISON_BUBBLES,
        RANKING,
        SHOW_SCORE_TOOLTIP,
        SCORE,
        MAIN_GROUP,
        COMPARISON_GROUP,
        ENTIRE_ORGANIZATION,
        ORGANIZATION,
        BOTTOM_DECILE,
        NO_BENCHMARK,
        UNIT_COMPARISON,
    } = SITE_TEXT || {};
    const compareBuLabel = getBuComparisonLabel(is_public_sector_ohi, COMPARE_BU, UNIT_COMPARISON);
    const buComparisonLabel = getBuComparisonLabel(is_public_sector_ohi, BU_COMPARISION, UNIT_COMPARISON);
    const [activeIndex, updateIndex] = useState(0);
    const [currentHover, setHover] = useState('');
    const [tornado, setTornado] = useState(false);
    const [showBu, setBuView] = useState(false);
    const [showReSurveyModal, setReSurveyModal] = useState(false);
    const [showResurveyView, setResurveyView] = useState(false);
    const [compOhid, setCompOhid] = useState({ ohid: '', year: '' });
    const [reSurveyFilter, updateFilterView] = useState(false);
    const [itemsToIterate, setItemsToIterate] = useState([]);

    useEffect(() => {
        if (is_public_sector_ohi) {
            setReSurveyModal(false);
            setResurveyView(false);
        }
    }, [is_public_sector_ohi]);

    const [buPracticeData, setBuPracticeData] = useState([]);
    const [dwnld, setdwnld] = useState(false);
    const { ranking = [], nSize, n_respondents, n_survey } = practiceData;
    const { sizes = {} } = buData || {};
    const { nSize: buNsize = [0, 0], n_respondents: buRespondents = [0, 0], n_survey: buNSurvey = [0, 0] } = sizes;
    const { title = '', items: mainPracticeData = [] } = ranking[activeIndex] || {};
    const mainData = useMemo(() => (showBu ? practiceBuData : mainPracticeData), [
        showBu,
        practiceBuData,
        mainPracticeData,
    ]);
    const topMainData = useMemo(() => mainData.slice(0, 10), [mainData]);
    const { ohid: oldId, year: oldYear, threshold } = apiParams;
    const { year: newYr = '' } = compOhid;
    const { pptAccessToken = '' } = AuthStore;
    const { Recipe_checkme_1, Recipe_checkme_second, practiceBoard } = PPT_VALUES({ rName });
    const { RANK_LABEL, RANK_VS_LABEL } = practiceBoard;
    const isV4 = survey_version === '4';
    const isV3 = survey_version === '3_2';
    const { filters: filterCheck = [] } = apiParams || {};
    const report_type = apiParams?.report_type || surveyType;

    // Memoize apiParams to prevent unnecessary re-renders
    const memoizedApiParams = useMemo(
        () => ({
            ...apiParams,
            report_type: apiParams?.report_type || surveyType,
        }),
        [
            apiParams?.ohid,
            apiParams?.year,
            apiParams?.threshold,
            JSON.stringify(apiParams?.filters || []),
            apiParams?.report_type,
            surveyType,
            apiParams?.benchmarks,
        ]
    );

    // Extract scoreData properties (these are used in multiple places)
    const { qbyq = {} } = scoreData;
    const { records = {} } = qbyq;
    const { ohi_score, ...dataToIterate } = records;
    let count = -1;
    const [scoreTabChecked, setscoreTabChecked] = useState(false);
    const [currentView, setReport] = useState(0);
    const [sizeToUse, updateSize] = useState([0, 0]);
    const [surveyRespondents, updateSurveyRes] = useState([0, 0]);
    const [surveys, updateSurveys] = useState([0, 0]);
    const [projectInFilter, setProjectinFilter] = useState([]);
    const [showPracticeBu, setShowPracticeBu] = useState(false);
    const [isToggled, setToggled] = useState(false);
    const isDefaultPracticeView = !showPracticeBu && !showBu && !showResurveyView;
    const isDefaultDataReady = isDefaultPracticeView && practiceDataFetched && scoreDataFetched && !apiLoadingCount;
    const isBuComparisonView = showPracticeBu || showBu;
    const isBuDataReady = isBuComparisonView && practiceBuDataFetched && !apiLoadingCount;
    const defaultViewKey = useMemo(() => JSON.stringify(memoizedApiParams.filters || []), [memoizedApiParams]);
    const isIngClient = report_id === parseInt(ING_REPORT_ID, 10);
    const isNonProfitSurvey = engagement === NON_PROFIT_SURVEY;

    const handleChange = event => {
        setscoreTabChecked(event.target.checked);
    };
    function extractSlug2Values(inputArray) {
        return inputArray.map(item => item.slug2);
    }
    const slug2Array = useMemo(() => extractSlug2Values(mainPracticeData), [mainPracticeData]);

    // Calculate dynamic split points for ranking based on actual data length
    const totalPractices = slug2Array.length;
    const topCount = Math.min(12, Math.floor(totalPractices / 3));
    const bottomCount = Math.min(12, Math.floor(totalPractices / 3));
    const middleEndIndex = Math.max(topCount, totalPractices - bottomCount);

    // Compute start index for middle so we don't repeat the last rank of top (e.g. rank 12 in both top and middle)
    const topEndIndexExclusive = useMemo(() => {
        if (!mainPracticeData.length || topCount <= 0) return topCount;
        const lastRankInTop = mainPracticeData[topCount - 1].index;
        let i = topCount;
        while (i < mainPracticeData.length && mainPracticeData[i].index === lastRankInTop) {
            i += 1;
        }
        return i;
    }, [mainPracticeData, topCount]);

    // Compute start index for bottom so we don't repeat the last rank of middle
    const bottomStartIndex = useMemo(() => {
        if (!mainPracticeData.length || middleEndIndex >= mainPracticeData.length) return totalPractices - bottomCount;
        const lastRankInMiddle = mainPracticeData[middleEndIndex - 1].index;
        let i = middleEndIndex;
        while (i < mainPracticeData.length && mainPracticeData[i].index === lastRankInMiddle) {
            i += 1;
        }
        return i;
    }, [mainPracticeData, middleEndIndex, totalPractices, bottomCount]);

    // Helper function to get slice with duplicate ranks included
    const getSliceWithDuplicates = (startIdx, endIdx) => {
        if (startIdx >= mainPracticeData.length) return [];

        const result = [];
        const endIdxToUse = Math.min(endIdx, mainPracticeData.length);

        // Get the main slice
        for (let i = startIdx; i < endIdxToUse; i += 1) {
            result.push(mainPracticeData[i].slug2);
        }

        // If we have items in the slice, check for duplicates at the boundary
        if (result.length > 0 && endIdxToUse < mainPracticeData.length) {
            const lastRankInSlice = mainPracticeData[endIdxToUse - 1].index;

            // Include any subsequent items with the same rank as the last item
            for (let i = endIdxToUse; i < mainPracticeData.length; i += 1) {
                if (mainPracticeData[i].index === lastRankInSlice) {
                    result.push(mainPracticeData[i].slug2);
                } else {
                    break; // Stop when we hit a different rank
                }
            }
        }

        return result;
    };

    // Get slices for each ranking section with duplicate handling (no rank repeated across sections)
    const topRankingSlice = useMemo(() => getSliceWithDuplicates(0, topCount), [mainPracticeData, topCount]);

    const middleRankingSlice = useMemo(() => getSliceWithDuplicates(topEndIndexExclusive, middleEndIndex), [
        mainPracticeData,
        topEndIndexExclusive,
        middleEndIndex,
    ]);

    const bottomRankingSlice = useMemo(() => getSliceWithDuplicates(bottomStartIndex, totalPractices), [
        mainPracticeData,
        bottomStartIndex,
        totalPractices,
    ]);

    const projectsInUse = useMemo(() => {
        return projects.filter(({ ohid }) => ohid !== currentOhid);
        // eslint-disable-next-line
    }, [currentOhid, projects]);

    // Derive QbyqArr from scoreData and mainPracticeData - no useEffect/setState to avoid infinite loop
    const QbyqArr = useMemo(() => {
        if (!scoreData?.qbyq?.records || !mainPracticeData?.length) return [];

        const keyIndexMap = {};
        mainPracticeData.forEach(item => {
            if (item.slug2 && item.index !== undefined) {
                keyIndexMap[item.slug2] = item.index;
            }
        });

        const data = [];
        Object.keys(dataToIterate).forEach(innerContent => {
            const { children = {} } = records[innerContent];
            Object.keys(children).forEach(childVal => {
                const { display_name, range_start, range_end, score, quartile } = children[childVal];
                const responseIndex = keyIndexMap[childVal];
                data.push({
                    key: childVal,
                    display_name,
                    range_start,
                    range_end,
                    score,
                    quartileFlag: !!(quartile === '0' || quartile === '1'),
                    quartile,
                    index: responseIndex,
                });
            });
        });

        return data.sort((a, b) => {
            const indexA = keyIndexMap[a.key] ?? Number.MAX_SAFE_INTEGER;
            const indexB = keyIndexMap[b.key] ?? Number.MAX_SAFE_INTEGER;
            return indexA - indexB;
        });
    }, [scoreData, mainPracticeData]);

    useEffect(() => {
        if (!practiceDataFetched && !apiLoadingCount && !showPracticeBu) {
            getPracticeData(memoizedApiParams);
        }
        if (!scoreDataFetched && !apiLoadingCount && !showPracticeBu) {
            getScoreData(memoizedApiParams);
        }
        if (showBu && practiceBuDataFetched) {
            if (tornado) {
                setItemsToIterate(sortArray(practiceBuData, 'value'));
            } else {
                setItemsToIterate(practiceBuData);
            }
            setResurveyView(false);
        }
        // eslint-disable-next-line
    }, [
        practiceDataFetched,
        scoreDataFetched,
        memoizedApiParams,
        showBu,
        practiceBuData,
        practiceBuDataFetched,
        showPracticeBu,
        apiLoadingCount,
    ]);

    useEffect(() => {
        if (!isDefaultDataReady) {
            return;
        }

        const { ranking: oldRanking = [] } = practiceData;
        if (!oldRanking.length) {
            return;
        }

        let indexToUse = 0;
        if (practiceToDisplay) {
            const foundIndex = oldRanking.findIndex(({ title: oldTitle }) => oldTitle.includes(practiceToDisplay));
            if (foundIndex !== -1) {
                indexToUse = foundIndex;
            }
        }

        const { items = [] } = oldRanking[indexToUse] || {};
        updateIndex(indexToUse);
        setItemsToIterate(tornado ? sortArray(items, 'value') : items);
        // eslint-disable-next-line
    }, [isDefaultDataReady, practiceData, practiceToDisplay, tornado, defaultViewKey]);

    useEffect(() => {
        if (!showPracticeBu || !practiceBuDataFetched || !practiceBuData.length) {
            return;
        }

        setBuPracticeData(tornado ? sortArray(practiceBuData, 'value') : practiceBuData);
        setResurveyView(false);
    }, [showPracticeBu, practiceBuDataFetched, practiceBuData, tornado]);

    const buPayload = (newFilters, orgComparisonEnabled = isEntireOrganizationSelected) => {
        const filtersArray = [];
        const { demographics = [], benchmarks: oldBench = [] } = newFilters[0];
        const { demographics: buDemo = [] } = newFilters[1] || {};
        demographics.forEach(({ options = [], code: parentCode = '' }, indexInDemo) => {
            const optionsCode = options
                .filter(({ isSelected }) => isSelected)
                .reduce((pre, { code }) => [...pre, code], []);
            const { options: buOptions = [] } = buDemo[indexInDemo] || {};
            const buOptionsCode = buOptions
                .filter(({ isSelected }) => isSelected)
                .reduce((pre, { code }) => [...pre, code], []);
            const preStr = optionsCode.length ? `${parentCode}:${optionsCode.join(',')}` : '';
            const endStr = buOptionsCode.length ? `${parentCode}:${buOptionsCode.join(',')}` : '';
            if (preStr || endStr) {
                filtersArray.push(`${preStr}||${endStr}`);
            }
        });
        return {
            ohid: `${oldId},${oldId}`,
            lang: parseInt(lang, 10),
            year: oldYear,
            threshold,
            filters: filtersArray,
            benchmarks: getBenchmarkString(oldBench),
            is_org_level_data: orgComparisonEnabled ? 1 : 0,
        };
    };

    const fetchBuData = (newFilters, orgComparisonEnabled = isEntireOrganizationSelected) => {
        const payload = buPayload(newFilters, orgComparisonEnabled);
        getPracticeBuData(payload);
        if (showPracticeBu) {
            getBuData(payload);
        }
    };

    const getFilteredApiParams = (demographics, oldBench) => ({
        ...memoizedApiParams,
        ...updateFilterParams(demographics, oldBench),
    });

    const refetchDataForCurrentView = (
        newFilters,
        demographics,
        oldBench,
        orgComparisonEnabled = isEntireOrganizationSelected
    ) => {
        const { demographics: newBuFilters = [] } = newFilters[1] || {};

        if (showPracticeBu || showBu) {
            fetchBuData([newFilters[0], { demographics: newBuFilters }], orgComparisonEnabled);
            return;
        }

        if (showResurveyView) {
            resetReSurveyDataFetched(false);
            return;
        }

        const nextParams = getFilteredApiParams(demographics, oldBench);
        getPracticeData(nextParams);
        getScoreData(nextParams);
    };

    const resetToDefaultPracticeView = useCallback(() => {
        setBuView(false);
        setShowPracticeBu(false);
        setResurveyView(false);
        updateFilterView(false);
        setBuPracticeData([]);
        setItemsToIterate([]);
        setToggled(false);
        updateIndex(0);
        resetPracticeBuDataFetched(true);
        getPracticeData(memoizedApiParams);
        getScoreData(memoizedApiParams);
    }, [getPracticeData, getScoreData, memoizedApiParams, resetPracticeBuDataFetched]);

    useEffect(() => {
        if (!practiceBuDataFetched && !apiLoadingCount && (showPracticeBu || showBu)) {
            resetPracticeBuDataFetched(true);
            fetchBuData([filters[0], { demographics: practiceFilters }]);
        }
        // eslint-disable-next-line
    }, [practiceBuDataFetched, practiceFilters, memoizedApiParams, filters, apiLoadingCount]);

    const setFilters = (newFilters, filtersApplied, orgComparisonEnabled = isEntireOrganizationSelected) => {
        updateFilterView(false);
        updateEntireOrganizationComparison({ context: 'practiceRanking', enabled: orgComparisonEnabled });
        const { demographics = [], benchmarks: oldBench = [] } = newFilters[0];
        let { demographics: newBuFilters = [] } = newFilters[1] || {};
        if (orgComparisonEnabled) {
            newBuFilters = clearDemographicSelections(newBuFilters);
        }
        const updatedParams = updateFilterParams(demographics, oldBench);

        updateFilters({ filters: [newFilters[0]], filtersApplied, apiParams: { ...apiParams, ...updatedParams } });
        updatePracticeBuFilters(newBuFilters);
        setItemsToIterate([]);
        setBuPracticeData([]);
        updateIndex(0);
        refetchDataForCurrentView(newFilters, demographics, oldBench, orgComparisonEnabled);
    };

    const setResurveyFilters = (newFilters, filtersApplied) => {
        updateFilterView(false);
        const { demographics = [], benchmarks: oldBench = [] } = newFilters[0];
        const updatedParams = updateFilterParams(demographics, oldBench);
        const filtersToSend = currentView < 3 ? newFilters : [newFilters[0]];

        updateFilters({ filters: filtersToSend, filtersApplied, apiParams: { ...apiParams, ...updatedParams } });
        setItemsToIterate([]);
        setBuPracticeData([]);
        updateIndex(0);
        refetchDataForCurrentView(filtersToSend, demographics, oldBench);
    };

    useEffect(() => {
        if (currentView < 3 && Object.keys(practiceDataCompYr).length) {
            const { ohid: prevOhid = '' } = compOhid || {};
            const { nSize: nSizes = '', n_respondents: nRespondents = '', n_survey: nSurvey = '' } =
                practiceDataCompYr[prevOhid] || {};
            updateSize([nSize, nSizes]);
            updateSurveyRes([n_survey, nSurvey]);
            updateSurveys([n_respondents, nRespondents]);
        }
        // eslint-disable-next-line
    }, [practiceDataCompYr]);

    useEffect(() => {
        return () => {
            setPracticeDisplay('');
        };
        // eslint-disable-next-line
    }, []);

    const setNewData = ({ target }) => {
        const { value } = target;
        const { items = [] } = ranking[value];
        updateIndex(value);
        if (tornado) {
            setItemsToIterate(sortArray(items, 'value'));
        } else {
            setItemsToIterate(items);
        }
    };
    const sortChart = ({ checked }) => {
        setTornado(checked);
        const { items = [] } = ranking[activeIndex];
        const itmesToUse = showPracticeBu ? practiceBuData : items;
        if (checked) {
            const sortedArr = sortArray(itmesToUse, 'value');
            setBuPracticeData(sortedArr);
            setItemsToIterate(sortedArr);
        } else {
            setItemsToIterate(itmesToUse);
            setBuPracticeData(itmesToUse);
        }
    };

    const renderRow = ({
        index,
        display_name,
        background,
        color,
        styleBlack,
        score,
        topRanking,
        bottomRanking,
        borderColor,
    }) => {
        return (
            <div
                className="tableRow"
                key={index}
                style={{
                    // eslint-disable-next-line no-nested-ternary
                    color: topRanking ? '#0679C3' : bottomRanking ? '#D51F31' : 'initial',
                }}
            >
                <span
                    className="recipe"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        // eslint-disable-next-line no-nested-ternary
                        color: topRanking ? '#0679C3' : bottomRanking ? '#D51F31' : 'initial',
                    }}
                >
                    <div
                        style={{
                            borderRadius: topRanking ? '50%' : 'initial',
                            background: topRanking ? '#F2F2F2' : 'initial',
                            fontWeight: topRanking ? '500' : 'initial',
                            padding: '0px 12px',
                        }}
                    >
                        {index}
                    </div>
                </span>
                <span
                    className="score "
                    style={{
                        fontWeight: topRanking ? '500' : 'initial',
                    }}
                >
                    {display_name}
                </span>
                <span className="scoreTab">
                    {scoreTabChecked && (
                        <span
                            className="scoreCount"
                            style={{
                                background: `linear-gradient(135deg, ${borderColor} 25%, ${background} 25%)`,
                                color: score === '-' ? '#000000' : color,
                                ...styleBlack,
                                score,
                            }}
                        >
                            <span>{score}</span>
                        </span>
                    )}
                </span>
            </div>
        );
    };

    const getDataForPpt = () => {
        const mTable = [];
        const BPPTable = [];
        const gTable = mainData.filter(({ value }) => value < -10).map(({ text2 }) => text2);
        const mTableList = [];
        const gTableList = [];
        const BPPList = [];

        topMainData.forEach(({ text1 }) => {
            if (!topMainData.some(({ text2: mainText }) => mainText === text1)) {
                mTable.push(text1);
            }
        });
        Object.keys(dataToIterate).forEach(innerContent => {
            const { children = {} } = records[innerContent];
            Object.keys(children).forEach(childVal => {
                const { display_name, quartile } = children[childVal];
                if (BPP_LIST[childVal] && quartile === '4') {
                    BPPTable.push(display_name);
                }
            });
        });

        mTable.forEach((mTableEle, row_index) => {
            const is_bold = gTable.includes(mTableEle);
            mTableList.push(
                {
                    row_index,
                    column_index: 0,
                    is_bold,
                    value: '*',
                },
                {
                    row_index,
                    column_index: 1,
                    is_bold,
                    value: mTableEle,
                }
            );
        });
        gTable.forEach((gTableEle, row_index) => {
            const is_bold = mTable.includes(gTableEle);
            gTableList.push(
                {
                    row_index,
                    column_index: 0,
                    is_bold,
                    value: '*',
                },
                {
                    row_index,
                    column_index: 1,
                    is_bold,
                    value: gTableEle,
                }
            );
        });
        BPPTable.forEach((BPPEle, row_index) => {
            BPPList.push(
                {
                    row_index,
                    column_index: 0,
                    is_bold: true,
                    value: '*',
                },
                {
                    row_index,
                    column_index: 1,
                    is_bold: true,
                    value: BPPEle,
                }
            );
        });
        const mTableListLen = mTable.length;
        const gTableListLen = gTable.length;
        const BPPTListLen = BPPTable.length;
        const { benchmarks = [] } = filters[0];
        const label = getBenchmarkName(benchmarks);
        const commonEle = [
            {
                name: 'source',
                value: `${SOURCE_TEXT} ${rName} (${NUMBER_TEXT}=${nSize}); ${BENCHMARK_HEAD}: ${label} (${NUMBER_TEXT}=${n_respondents}, ${NUMBER_SURVEY_TEXT}=${n_survey})`,
            },
            {
                name: 'Checkme',
                is_delete: 'true',
            },
        ];
        const pptArray = [
            {
                name: 'Title_text',
                value: title,
            },
            {
                name: 'companyshape1',
                value: rName,
            },
            {
                name: 'txttopc',
                value: HIGH_PRACTICES,
            },
            {
                name: 'txttopa',
                value: RECIPE_TOP,
            },
            {
                name: 'txttopb',
                value: COMPARE_TO_RECIPE,
            },
            {
                name: 'txt3rd',
                value: UNDER_EMPHASIZED,
            },
            ...getPptValues(Recipe_checkme_1),
        ];
        const recipeTopPratice = [];
        const clientTopPratice = [];
        const chart_data = [];

        mainData.forEach(({ text1 }, row_index) => {
            const is_bold = row_index < 10 ? 'true' : 'false';
            recipeTopPratice.push(
                {
                    row_index,
                    column_index: 0,
                    is_bold,
                    value: row_index + 1,
                },
                {
                    row_index,
                    column_index: 1,
                    is_bold,
                    value: text1,
                }
            );
        });
        itemsToIterate.forEach(({ text2, index, value }, row_index) => {
            const is_bold = topMainData.some(({ text1: mainText }) => mainText === text2) ? 'true' : 'false';
            const bgcolor = value < -10 ? colors.$red300 : colors.$grey700;
            clientTopPratice.push(
                {
                    row_index,
                    column_index: 0,
                    is_bold,
                    value: index,
                },
                {
                    row_index,
                    column_index: 1,
                    is_bold,
                    value: text2,
                }
            );
            chart_data.push({
                index: row_index,
                value,
                bgcolor,
            });
        });
        const output = {
            template_file_name: 'Template_All.pptx',
            output_file_name: 'practice.pptx',
            slides: [
                {
                    identify_shape_name: 'Checkme',
                    identify_shape_value: 'Recipe_checkme_1',
                    is_copy: true,
                    is_delete: false,
                    data: [
                        ...commonEle,
                        ...pptArray,
                        {
                            name: 'recipeTopPratice_table',
                            is_delete: 'false',
                            table_data: recipeTopPratice,
                        },
                        {
                            name: 'ClientTopPratice_table',
                            is_delete: 'false',
                            table_data: clientTopPratice,
                        },
                        {
                            name: 'DifferenceCompanyRecipe_chart',
                            is_delete: 'false',
                            chart_data,
                        },
                    ],
                },
                {
                    identify_shape_name: 'Checkme',
                    identify_shape_value: 'Recipe_checkme_1',
                    is_delete: true,
                },
                {
                    identify_shape_name: 'Checkme',
                    identify_shape_value: 'Recipe_checkme_second',
                    is_copy: true,
                    is_delete: false,
                    data: [
                        ...commonEle,
                        ...getPptValues(Recipe_checkme_second),
                        {
                            name: 'Title_text',
                            value: `${ALL_PPT_TEXT[0]} ${title.substring(
                                title.lastIndexOf('(') + 1,
                                title.lastIndexOf(')')
                            )}`,
                        },
                        {
                            name: 'M_List',
                            is_delete: !!mTableListLen,
                            value: mTableListLen ? '' : ALL_PPT_TEXT[1],
                        },
                        {
                            name: 'M_Table',
                            is_delete: !mTableListLen,
                            table_data: mTableList,
                        },
                        {
                            name: 'BPP_List',
                            is_delete: !!BPPTListLen,
                            value: BPPTListLen ? '' : ALL_PPT_TEXT[2],
                        },
                        {
                            name: 'BPP_Table',
                            is_delete: !BPPTListLen,
                            table_data: BPPList,
                        },
                        {
                            name: 'G_List',
                            is_delete: !!gTableListLen,
                            value: gTableListLen ? '' : ALL_PPT_TEXT[3],
                        },
                        {
                            name: 'G_Table',
                            is_delete: !gTableListLen,
                            table_data: gTableList,
                        },
                    ],
                },
                {
                    identify_shape_name: 'Checkme',
                    identify_shape_value: 'Recipe_checkme_second',
                    is_delete: true,
                },
            ],
        };
        getPptData(output, pptAccessToken, `${report_name} Practice_Recipe_${activeIndex + 1}`);
    };

    const getSinglePageMeta = () => {
        const { practice_ranking = [] } = checkme_mapping || {};
        const defaultPage = cloneDeep(practice_ranking);
        defaultPage.splice(1, 1);
        if (showPracticeBu) {
            if (isV3) {
                return ['Recipe_checkme_bu_3_2'];
            }
            return ['Recipe_checkme_bu_4_0'];
        }
        if (showResurveyView) return ['Top_10_practice_over_time'];
        if (scoreTabChecked)
            return ['Client_practice_rank', 'Client_practice_rank_score', 'Client_practice_rank_score_2'];
        return defaultPage;
    };

    const v4PptDownload = () => {
        const addOns = {
            fill_threshold_with: demographic === '1' ? '-' : '',
            others: demographic === '3' ? 1 : 0,
        };
        const { benchmarks = [] } = filters[0];
        const label = getBenchmarkName(benchmarks);
        const valueToSend = {
            ...SINGLE_PAGE_EXPORT_PARAMS({ BENCHMARK_NAME: label }),
            ...addOns,
            report_name: rName,
            ...apiParams,
            report_id,
            single_page_meta: {
                checkme: getSinglePageMeta(),
                name: 'Practice_Ranking',
            },
            practice_rank_score_flag: !!scoreTabChecked,
        };
        setdwnld(true);
        getReport(valueToSend);
    };

    const getResurveyParams = useCallback(
        newFilters => {
            const { ohid: newId = '' } = compOhid || {};
            const selectedOhiId = [oldId, newId];
            const selectedIds = selectedOhiId;
            const ohid = `${selectedOhiId.join(',')}`;
            const compare_ids = selectedOhiId.map(selectId => `${oldId}-${selectId}`);

            const filtersArray = [];
            const benchmarksArray = [];
            newFilters.forEach(({ benchmarks: newB = [], demographics: newD = [] }, indexToUse) => {
                let benchMarkYear = oldYear;
                let preString = '';
                let endString = '';
                if (indexToUse) {
                    const project = selectedIds[indexToUse];
                    const projectIndex = projectsInUse.findIndex(({ ohid: id = '' }) => id === project);
                    if (isNaN(Number(projectIndex))) return;
                    const { year } = projectsInUse[projectIndex];
                    benchMarkYear = year;
                    preString = '||';
                    endString = '';
                } else {
                    endString = '||';
                }
                const filtersObtained = getFilterArray(newD, preString, endString);
                filtersObtained.forEach(result => {
                    filtersArray.push(result);
                });
                if (newB.length) {
                    benchmarksArray.push(`${getBenchmarkString(newB)}@${benchMarkYear}`);
                }
            });
            return {
                ohid,
                filters: filtersArray,
                benchmark_str: benchmarksArray.join(','),
                compare_ids,
                report_type,
                comparison_type: resurvey_settings.toLowerCase() === QUARTILE_RESURVEY ? 2 : 1,
                lang: parseInt(lang, 10),
            };
        },
        [compOhid, oldId, oldYear, projectsInUse, report_type, resurvey_settings, QUARTILE_RESURVEY, lang]
    );

    const v4PptDownloadResurvey = () => {
        const { benchmark_str, ohid } = getResurveyParams(filters);
        const { bm_filters } = apiParams;
        const addOns = {
            fill_threshold_with: demographic === '1' ? '-' : '',
            others: demographic === '3' ? 1 : 0,
        };
        const { key: Resurvey_SigVsQuartile = '' } =
            COMPARISON_BUBBLES.find(({ list_key }) => list_key.toLowerCase() === resurvey_settings.toLowerCase()) || {};
        const resurveyParams = {
            ...RESURVEY_EXPORT_PARAMS,
            ...addOns,
            report_name: rName,
            options: {
                ...RESURVEY_EXPORT_PARAMS.options,
                survey_names: `${ohid.split(',').join('$#$')}`,
                Resurvey_SigVsQuartile,
                resurvey_custom_delta,
            },
            bm_filters,
            benchmarks: benchmark_str,
            threshold,
            report_id,
        };
        const valueToSend = {
            ...resurveyParams,
            ...getResurveyParams(filters),
            single_page_meta: {
                checkme: getSinglePageMeta(),
                name: 'Practice_Ranking_Resurvey',
            },
        };
        setdwnld(true);
        getReport(valueToSend);
    };

    const buName = resolveEntireOrganizationComparisonLabel(AuthStore.practiceRankingBU || COMPARISON_GROUP, {
        isEntireOrganizationSelected,
        entireOrganizationLabel: ENTIRE_ORGANIZATION,
        organizationLabel: ORGANIZATION,
    });
    const practiceReportName = AuthStore.practiceReportBU || MAIN_GROUP;

    const v4PptDownloadBu = () => {
        const addOns = {
            fill_threshold_with: demographic === '1' ? '-' : '',
            others: demographic === '3' ? 1 : 0,
        };
        const { benchmarks = [] } = filters[0];
        const label = getBenchmarkName(benchmarks);
        const singlePageParams = SINGLE_PAGE_EXPORT_PARAMS({ BENCHMARK_NAME: label });
        const valueToSend = {
            ...singlePageParams,
            ...addOns,
            // report_name: rName,
            report_name: practiceReportName,
            bu_comparison_names: buName,
            ...apiParams,
            ...buPayload([filters[0], { demographics: practiceFilters }]),
            need_tornado_chart: tornado,
            report_id,
            single_page_meta: {
                checkme: getSinglePageMeta(),
                name: 'Practice_Ranking_BU',
            },
            options: {
                ...singlePageParams.options,
                ...(apiParams.options || {}),
                org_level_filter: isEntireOrganizationSelected,
            },
        };
        setdwnld(true);
        getReport(valueToSend);
    };

    const leftHeading = showBu ? buName : RANK_LABEL;
    const rightHeading = showBu ? `${rName} ${VS_LABEL} ${buName}` : `${RANK_VS_LABEL} ${title}`;
    const checkShowDwnld = () => {
        if (!isOhi4) return true;
        if (tornado || isToggled) return false;
        return true;
    };

    const showDwnld = checkShowDwnld();

    const callReSurveyApi = (currentIds, indexToUse = 0) => {
        const { ohid: newId, year: newYear } = projectsInUse[currentIds];
        setProjectinFilter([`${oldId} - ${oldYear}`, `${newId} - ${newYear}`]);
        getDemographics({ ohid: newId, lang: parseInt(lang, 10) }, indexToUse + 1);
        getBenchmarks({ ohid: newId, year: newYear, lang }, indexToUse + 1, benchmark);
        AuthStore[`resurveyName${indexToUse + 1}`] = `${newId} (${newYear})`;
        // resetReSurveyDataFetched(false);
    };

    const selectProject = (ohId, reportType) => {
        const { ohid, year } = projectsInUse[ohId] || {};
        setReSurveyModal(false);
        setCompOhid({ ohid, year: parseInt(year, 10) });
        setResurveyView(true);
        // updateFilterView(true);
        callReSurveyApi(ohId);
        setReport(reportType);
    };

    const showbreadCrumb = showPracticeBu ? buComparisonLabel : BU_HEAD;

    return (
        <>
            <div className="practiceBoard clearfix">
                <Helmet>
                    <title>{HEALTH_PRACTICE_RANKING}</title>
                </Helmet>

                {(showBu || showPracticeBu || showResurveyView) && (
                    <div className="breadCrumb">
                        <span
                            data-testid="setScoreFromBuBtn"
                            onClick={resetToDefaultPracticeView}
                            className="practiceText"
                        >
                            {PRACTICE_HEAD}
                        </span>
                        <span className="practiceText">{' > '}</span>
                        <span className="breadCrumbText">{showResurveyView ? RESURVEY_TEXT : showbreadCrumb}</span>
                    </div>
                )}
                <h2 className="clearfix">
                    {showBu || showPracticeBu || showResurveyView ? (
                        <span data-testid="setBackFromBuBtn" onClick={resetToDefaultPracticeView}>
                            <ArrowBack />
                            <span>
                                {showBu && <span>{PRACTICE_HEAD}</span>}
                                {showPracticeBu && <span>{buComparisonLabel}</span>}
                                {showResurveyView && <span>{RESURVEY_TEXT}</span>}
                            </span>
                        </span>
                    ) : (
                        <div className="practiceHeading">
                            <div className="mainHeading">{PRACTICE_HEAD}</div>
                            <div className="nRes">
                                {NUMBER_OF_RESPONDENTS_N} : <span>{nSize ? nSize.toLocaleString('en-US') : ''}</span>
                            </div>
                        </div>
                    )}
                    <ul className="rightSideNav">
                        {/* {showPracticeBu && (
                        <li>
                            <Checkbox checked={scoreTabChecked} onChange={handleChange} />
                            <span>show scores</span>
                        </li>
                    )} */}

                        {showPracticeBu && isV4 ? (
                            <li className="showPracticeToradoChart">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={tornado}
                                            onChange={({ target }) => sortChart(target)}
                                            disabled={isToggled}
                                            name="tornadoCheck"
                                            inputProps={{
                                                'data-testid': 'tornadoCheck',
                                            }}
                                        />
                                    }
                                    label={TORNADO_LABEL}
                                />
                            </li>
                        ) : null}

                        {(isV4 || showPracticeBu) && !isNonProfitSurvey ? (
                            <li>
                                <Tooltip title={showPracticeBu ? SHOW_SCORE_TOOLTIP : ''}>
                                    <FormControlLabel
                                        control={<Checkbox checked={scoreTabChecked} onChange={handleChange} />}
                                        label={SHOW_SCORES}
                                    />
                                </Tooltip>
                                <span className="lineHead" />
                            </li>
                        ) : null}
                        {!isV4 ? (
                            <li>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={tornado}
                                            onChange={({ target }) => sortChart(target)}
                                            name="tornadoCheck"
                                            inputProps={{
                                                'data-testid': 'tornadoCheck',
                                            }}
                                        />
                                    }
                                    label={TORNADO_LABEL}
                                />
                            </li>
                        ) : null}
                        {!showPracticeBu && isV4 && !is_public_sector_ohi ? (
                            <li
                                data-testid="setReSurveyModalBtn"
                                onClick={() => setReSurveyModal(true)}
                                className="fImage resurveyImg"
                            >
                                <img src={BulletList} alt="" />
                                <span className="upperHead">{RESURVEY_TEXT}</span>
                            </li>
                        ) : null}
                        {!showBu &&
                            (!isOhi4 ? (
                                <li
                                    data-testid="setBuReportBtn"
                                    onClick={() => {
                                        setItemsToIterate([]);
                                        setBuView(true);
                                        resetPracticeBuDataFetched(false);
                                    }}
                                >
                                    <img src={CompareView} alt="" />
                                    <span className="upperHead">{compareBuLabel}</span>
                                </li>
                            ) : null)}

                        {(isV4 || isV3) && !showPracticeBu && !showResurveyView ? (
                            <li
                                data-testid="setBuReportBtn"
                                onClick={() => {
                                    // setItemsToIterate([]);
                                    setShowPracticeBu(true);
                                    resetPracticeBuDataFetched(false);
                                }}
                            >
                                <img src={comparisonBu} alt="" />
                                <span className="upperHead">{compareBuLabel}</span>
                            </li>
                        ) : null}

                        {!errorInfo && !isIngClient && !isNonProfitSurvey && showDwnld && (
                            <li
                                data-testid="getPptBtn"
                                onClick={() => {
                                    if (isV4 || isV3) {
                                        if (showResurveyView) {
                                            v4PptDownloadResurvey();
                                        } else if (showPracticeBu) {
                                            v4PptDownloadBu();
                                        } else {
                                            v4PptDownload();
                                        }
                                    } else {
                                        getDataForPpt();
                                    }
                                }}
                            >
                                <img src={Down} alt="" />
                                <span className="lineHead upperHead">{DOWNLOAD}</span>
                            </li>
                        )}
                        <li
                            onClick={() => {
                                if (showBu || showPracticeBu || showResurveyView) {
                                    updateFilterView(true);
                                } else {
                                    toggleFilterView(true);
                                }
                            }}
                            data-testid="filterButton"
                            className="filterBtn"
                        >
                            <img
                                className="imgView"
                                src={activeFilter && filterCheck.length > 0 ? ActiveFilters1 : FilterSvg}
                                alt=""
                            />
                            <span className="filter">{FILTERS}</span>
                        </li>
                    </ul>
                </h2>
                {/* {appliedFiltersInfo()} */}
                {!showPracticeBu && !showResurveyView && appliedFiltersInfo()}
                {/* {showResurveyView && appliedFiltersInfo([oldYear, newYear])} */}
                {errorInfo && <ErrorToast message={errorInfo} />}
                {dwnld && !reportError && (
                    <DwnldModal
                        getRawPptData={getRawPptData}
                        reportId={report_id}
                        open={dwnld}
                        setOpen={setdwnld}
                        getSinglePastReport={getSinglePastReport}
                        singlePastReport={singlePastReport}
                        defaultSettings={defaultSettings}
                    />
                )}

                {isDefaultDataReady && mainData.length && !isV3 && !isV4 ? (
                    <section>
                        <section className="topBoard clearfix">
                            <div className="leftBoard">
                                {showBu ? (
                                    <span>{rName}</span>
                                ) : (
                                    <Select
                                        labelId="practiceOptions"
                                        value={activeIndex}
                                        onChange={setNewData}
                                        IconComponent={ExpandMore}
                                        data-testid="practiceOptions"
                                    >
                                        {ranking.map(({ title: selectOption }, menuIndex) => (
                                            <MenuItem
                                                key={selectOption}
                                                value={menuIndex}
                                                classes={{ root: 'practiceOptions' }}
                                            >
                                                {selectOption}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            </div>

                            <div className="rightBoard">
                                <div>{leftHeading}</div>
                                <div className="ellipsisPro">{rightHeading}</div>
                            </div>
                        </section>

                        <section className="rankBoard clearfix">
                            <div className="leftHead">
                                {mainData.map(({ text1 }, leftIndex) => (
                                    <div
                                        onMouseOver={() => setHover(text1)}
                                        onMouseOut={() => setHover('')}
                                        key={text1}
                                        className={c('ellipsisPro', {
                                            topRank: leftIndex < 10,
                                            hovered: text1 === currentHover,
                                        })}
                                    >
                                        <span>{addZeroToNUmber(leftIndex + 1)}</span> {text1}
                                    </div>
                                ))}
                            </div>
                            <div className="rightItems">
                                {itemsToIterate.map(({ text2, value, index }) => (
                                    <section className="clearfix" key={text2}>
                                        <div
                                            onMouseOver={() => setHover(text2)}
                                            onMouseOut={() => setHover('')}
                                            className={c('ellipsisPro', {
                                                topRank: topMainData.some(({ text1 }) => text1 === text2),
                                                hovered: text2 === currentHover,
                                            })}
                                        >
                                            <span>{addZeroToNUmber(index)}</span> {text2}
                                        </div>
                                        <div className="clearfix">
                                            <div className={c('rank', { negative: value < 0 })}>
                                                <div
                                                    className={c('textBorder', { emphasised: value < -10 })}
                                                    style={{
                                                        width: `${2 * Math.abs(value)}%`,
                                                    }}
                                                >
                                                    <div className="textRank">{value}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                ))}
                                <div className="rightHighLight">
                                    <div />
                                </div>
                            </div>
                        </section>

                        <ul className="legends clearfix">
                            <li>
                                {LEGEND} : <span className="colored">{HIGH_PRACTICES}</span>
                                <span className="recipe">{RECIPE_TOP}</span>
                            </li>
                            <li>
                                <span className="bullet" />
                                {UNDER_EMPHASIZED}
                            </li>
                            <li>
                                <span className="bullet" />
                                {COMPARE_TO_RECIPE}
                            </li>
                        </ul>
                    </section>
                ) : null}

                {isDefaultDataReady && mainData.length && isV4 ? (
                    <section className="isV4" key={defaultViewKey}>
                        <div
                            style={{ display: 'flex', justifyContent: 'space-between' }}
                            className="leftHead leftSection"
                        >
                            <div style={{ width: '32%' }}>
                                <div className="rank-head">
                                    <div className="topRanking">{TOP_RANKING}</div>
                                </div>
                                <div className="PracticeRankTable">
                                    <div className="tableHeading">
                                        <span className="recipe "> {RANK}</span>
                                        <span className="score "> {PRACTICES}</span>
                                        {scoreTabChecked && <span className="range">{SCORE}</span>}
                                    </div>

                                    {topRankingSlice.map(slug => {
                                        const item = QbyqArr.find(({ key }) => key === slug);
                                        if (!item) return null;

                                        const {
                                            display_name,
                                            score,
                                            range_end,
                                            range_start,
                                            quartileFlag,
                                            quartile,
                                            index: responseIndex,
                                        } = item;

                                        const { color, background = $white, border } = quartileColors[quartile] || {};
                                        const styleBlack =
                                            quartile === ('' || 999) ? { border: '2px solid #000000' } : {};

                                        count += 1;
                                        return renderRow({
                                            index: responseIndex || count,
                                            display_name,
                                            background,
                                            color,
                                            styleBlack,
                                            quartile,
                                            score,
                                            range_start,
                                            range_end,
                                            quartileFlag,
                                            topRanking: true,
                                            borderColor: border,
                                        });
                                    })}
                                </div>
                            </div>
                            <div style={{ width: '32%' }}>
                                <div className="rank-head">
                                    <div className="middleRanking">{MIDDLE_RANKING}</div>
                                </div>
                                <div className="PracticeRankTable">
                                    <div className="tableHeading">
                                        <span className="recipe ">{RANK}</span>
                                        <div className="score ">{PRACTICES}</div>
                                        {scoreTabChecked && <span className="range">{SCORE}</span>}
                                    </div>
                                    {middleRankingSlice.map(slug => {
                                        const item = QbyqArr.find(({ key }) => key === slug);
                                        if (!item) return null;

                                        const {
                                            display_name,
                                            score,
                                            range_end,
                                            range_start,
                                            quartileFlag,
                                            quartile,
                                            index: responseIndex,
                                        } = item;

                                        const { color, background = $white, border = '' } =
                                            quartileColors[quartile] || {};
                                        const styleBlack =
                                            quartile === ('' || 999) ? { border: '2px solid #000000' } : {};

                                        count += 1;
                                        return renderRow({
                                            index: responseIndex || count,
                                            display_name,
                                            background,
                                            color,
                                            styleBlack,
                                            quartile,
                                            score,
                                            range_start,
                                            range_end,
                                            quartileFlag,
                                            borderColor: border,
                                        });
                                    })}
                                </div>
                            </div>
                            <div style={{ width: '32%' }}>
                                <div className="rank-head">
                                    <div className="bottomRanking">{BOTTOM_RANKING}</div>
                                </div>
                                <div className="PracticeRankTable">
                                    <div className="tableHeading">
                                        <span className="recipe ">{RANK}</span>
                                        <div className="score ">{PRACTICES}</div>
                                        {scoreTabChecked && <span className="range">{SCORE}</span>}
                                    </div>
                                    {bottomRankingSlice.map(slug => {
                                        const item = QbyqArr.find(({ key }) => key === slug);
                                        if (!item) return null;

                                        const {
                                            display_name,
                                            score,
                                            range_end,
                                            range_start,
                                            quartileFlag,
                                            quartile,
                                            index: responseIndex,
                                        } = item;

                                        const { color, background = $white, border = '' } =
                                            quartileColors[quartile] || {};
                                        const styleBlack =
                                            quartile === ('' || 999) ? { border: '2px solid #000000' } : {};

                                        count += 1;
                                        return renderRow({
                                            index: responseIndex || count,
                                            display_name,
                                            background,
                                            color,
                                            styleBlack,
                                            quartile,
                                            score,
                                            range_start,
                                            range_end,
                                            quartileFlag,
                                            bottomRanking: true,
                                            borderColor: border,
                                        });
                                    })}
                                </div>
                            </div>
                        </div>
                    </section>
                ) : null}

                {isDefaultDataReady && mainData.length && isV3 ? (
                    <section>
                        <section className="topBoard clearfix topHead">
                            <div className="leftBoard newLeftBoard">
                                <div className="rankBoard">{RANK}</div>
                                <div className="secondHead">
                                    {showBu ? (
                                        <span>{rName}</span>
                                    ) : (
                                        <Select
                                            labelId="practiceOptions"
                                            value={activeIndex}
                                            onChange={setNewData}
                                            IconComponent={ExpandMore}
                                            data-testid="practiceOptions"
                                        >
                                            {ranking.map(({ title: selectOption }, menuIndex) => (
                                                <MenuItem
                                                    key={selectOption}
                                                    value={menuIndex}
                                                    classes={{ root: 'practiceOptions' }}
                                                >
                                                    {selectOption}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )}
                                </div>
                            </div>

                            <div className="rightBoard rightHead">
                                <div className="heading">{leftHeading}</div>
                                <div className="ellipsisPro" style={{ paddingLeft: '2vh' }}>
                                    {rightHeading}
                                </div>
                            </div>
                        </section>

                        <section className="rankBoard clearfix rankSection">
                            <div className="leftHead leftSection">
                                {mainData.map(({ text1 }, leftIndex) => (
                                    <div
                                        onMouseOver={() => setHover(text1)}
                                        onMouseOut={() => setHover('')}
                                        key={text1}
                                        className={c('ellipsisPro leftPro', {
                                            topRank: leftIndex < 10,
                                            hovered: text1 === currentHover,
                                        })}
                                    >
                                        <div className="leftContent">
                                            <div className="leftIndex">
                                                <div>{addZeroToNUmber(leftIndex + 1)}</div>
                                            </div>
                                            <div className="rightText">{text1}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="rightItems rightSection">
                                {itemsToIterate.map(({ text2, value }) => (
                                    <section className="clearfix itemSection" key={text2}>
                                        <div
                                            onMouseOver={() => setHover(text2)}
                                            onMouseOut={() => setHover('')}
                                            className={c('ellipsisPro linePro', {
                                                topRank: topMainData.some(({ text1 }) => text1 === text2),
                                                hovered: text2 === currentHover,
                                            })}
                                        >
                                            <div className="rightText">
                                                <div>{text2}</div>
                                            </div>
                                        </div>
                                        <div className="clearfix">
                                            <div className={c('rank rankContent', { negative: value < 0 })}>
                                                <div
                                                    className={c('textBorder', { emphasised: value < -10 })}
                                                    style={{
                                                        width: `${2 * Math.abs(value)}%`,
                                                    }}
                                                >
                                                    <div className="textRank">{value}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                ))}
                                <div className="rightHighLight">
                                    <div className="rankHighLight" />
                                </div>
                            </div>
                        </section>
                        <div>
                            <ul className="legends clearfix">
                                <li>
                                    {LEGEND} : <span className="colored">{HIGH_PRACTICES}</span>
                                    <span className="recipe">{RECIPE_TOP}</span>
                                </li>
                                <li>
                                    <span className="bullet" />
                                    {UNDER_EMPHASIZED}
                                </li>
                                <li>
                                    <span className="bullet" />
                                    {COMPARE_TO_RECIPE}
                                </li>
                            </ul>
                        </div>
                    </section>
                ) : null}

                {reSurveyFilter && (showPracticeBu || showBu) && !showResurveyView && (
                    <FilterBar
                        activeResetFilter={activeFilter}
                        size={isOhi4 ? buNsize : [nSize, 0]}
                        surveyRespondents={isOhi4 ? buRespondents : [n_respondents, 0]}
                        surveys={isOhi4 ? buNSurvey : [n_survey, 0]}
                        filters={[filters[0], { demographics: practiceFilters }]}
                        projectInFilter={BU_PROJECTS}
                        currentView={6}
                        showBenchmarks={false}
                        closeFilters={updateFilterView}
                        setFilters={setFilters}
                        defaultBenchmark={benchmark}
                        defaultSettings={defaultSettings}
                        years={[oldYear, oldYear]}
                        isEntireOrganizationSelected={isEntireOrganizationSelected}
                        updateEntireOrganizationComparison={updateEntireOrganizationComparison}
                        entireOrganizationContext="practiceRanking"
                    />
                )}
                {reSurveyFilter && showResurveyView && !(showPracticeBu || showBu) && (
                    <FilterBar
                        activeResetFilter={activeFilter}
                        size={sizeToUse}
                        surveyRespondents={surveyRespondents}
                        surveys={surveys}
                        filters={filters}
                        projectInFilter={projectInFilter}
                        currentView={currentView}
                        showBenchmarks
                        closeFilters={updateFilterView}
                        setFilters={setResurveyFilters}
                        defaultBenchmark={benchmark}
                        defaultSettings={defaultSettings}
                        years={[oldYear, newYr]}
                    />
                )}
                {showReSurveyModal && !is_public_sector_ohi && (
                    <SelectModal
                        defaultSettings={defaultSettings}
                        oldSelectedId={compOhid.ohid}
                        projects={projectsInUse}
                        projectsFetched={projectsFetched}
                        closeModal={setReSurveyModal}
                        selectProject={selectProject}
                        practiceRankModal
                    />
                )}
                {showPracticeBu && isBuDataReady ? (
                    <PracticeBuBoard
                        apiParams={apiParams}
                        defaultSettings={defaultSettings}
                        // practiceBuData={itemsToIterate}
                        practiceBuData={buPracticeData}
                        practiceBuDataFetched={practiceBuDataFetched}
                        buData={buData}
                        buDataFetched={buDataFetched}
                        isChecked={scoreTabChecked}
                        tornado={tornado}
                        isToggled={isToggled}
                        setToggled={setToggled}
                        practiceDataHere={practiceBuData}
                        updateFilters={updateFilters}
                        toggleFilterView={toggleFilterView}
                        // updateBuFilters={updateBuFilters}
                        resetPracticeBuDataFetched={resetPracticeBuDataFetched}
                        filters={[filters[0], { demographics: practiceFilters }]}
                        setFilters={setFilters}
                        isEntireOrganizationSelected={isEntireOrganizationSelected}
                    />
                ) : null}
                {showResurveyView && !is_public_sector_ohi ? (
                    <ResurveyBoard
                        practiceDataCompYr={practiceDataCompYr}
                        getComparisonYrPracticeData={getComparisonYrPracticeData}
                        apiParams={apiParams}
                        compOhid={compOhid}
                        apiLoadingCount={apiLoadingCount}
                        practiceData={practiceData}
                        scoreData={scoreData}
                        defaultSettings={defaultSettings}
                        isChecked={scoreTabChecked}
                        filters={filters}
                        setFilters={setResurveyFilters}
                        getResurveyParams={getResurveyParams}
                        getReSurveyData={getReSurveyData}
                        getPracticeResurveyData={getPracticeResurveyData}
                        resurveyDataHere={practiceResurveyData}
                        practiceResurveyData={practiceResurveyData}
                        isToggled={isToggled}
                        reSurveyDataVal={reSurveyData}
                        reSurveyDataFetched={reSurveyDataFetched}
                        resetReSurveyDataFetched={resetReSurveyDataFetched}
                        reportsData={reportsData}
                        getReports={getReports}
                        reportsDataFetched={reportsDataFetched}
                    />
                ) : null}
            </div>
            {/* new  */}
            <ul className="fixedScoreCardSurvey">
                <div className="rankingInfo">
                    <div className="sub-head">{RANKING}:</div>
                    <div className="topRank" /> {TOP_RANKING}
                    <div className="bottomRank" /> {BOTTOM_RANKING}
                </div>
                {scoreTabChecked ? (
                    <div>
                        <ul className="benchmark clearfix">
                            <li>{BENCHMARK_HEAD} : </li>
                            {quartileColors
                                .slice()
                                .reverse()
                                .map(({ title: label = '', background, border: borderColor }) => {
                                    const bottomDecileVar = label === BOTTOM_DECILE;
                                    const BenchmarkTitle = label === NO_BENCHMARK;
                                    return (
                                        <li
                                            key={label}
                                            style={{ color: background }}
                                            className={c({
                                                hide: bottomDecileVar || BenchmarkTitle,
                                            })}
                                        >
                                            <span
                                                className="benchmarkTriangle"
                                                style={{
                                                    background,
                                                    borderWidth: '13px 13px 0 0',
                                                    borderColor: bottomDecileVar
                                                        ? `transparent ${borderColor} transparent transparent`
                                                        : `${borderColor} transparent transparent transparent`,
                                                    borderStyle: 'solid',
                                                }}
                                            />
                                            <div style={{ color: 'black', fontWeight: '400' }}>{label}</div>
                                        </li>
                                    );
                                })}
                        </ul>
                        <div className="noteInfo">
                            <b>{NOTE} : </b>
                            <br />
                            1. {PRACTICE_RANKING_NOTE}
                            <br />
                            {surveyType === 'percent favorable' && <div>2. {PERCENT_FAVORABLE}</div>}
                            {surveyType === 'percentile' && <div>2. {PERCENTILES}</div>}
                        </div>
                    </div>
                ) : null}
            </ul>
        </>
    );
}

PracticeBoard.propTypes = {
    filters: PropTypes.array.isRequired,
    errorInfo: PropTypes.string.isRequired,
    practiceToDisplay: PropTypes.string.isRequired,
    apiParams: PropTypes.object.isRequired,
    apiLoadingCount: PropTypes.number.isRequired,
    practiceData: PropTypes.object.isRequired,
    activeFilter: PropTypes.bool.isRequired,
    practiceDataFetched: PropTypes.bool.isRequired,
    practiceBuDataFetched: PropTypes.bool.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    scoreDataFetched: PropTypes.bool.isRequired,
    practiceFilters: PropTypes.array.isRequired,
    isEntireOrganizationSelected: PropTypes.bool.isRequired,
    updateEntireOrganizationComparison: PropTypes.func.isRequired,
    practiceBuData: PropTypes.array.isRequired,
    practiceResurveyData: PropTypes.object.isRequired,
    scoreData: PropTypes.object.isRequired,
    getScoreData: PropTypes.func.isRequired,
    getPracticeData: PropTypes.func.isRequired,
    getPracticeBuData: PropTypes.func.isRequired,
    toggleFilterView: PropTypes.func.isRequired,
    getPptData: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    updatePracticeBuFilters: PropTypes.func.isRequired,
    setPracticeDisplay: PropTypes.func.isRequired,
    resetPracticeBuDataFetched: PropTypes.func.isRequired,
    appliedFiltersInfo: PropTypes.func.isRequired,
    getRawPptData: PropTypes.func.isRequired,
    getReport: PropTypes.func.isRequired,
    reportError: PropTypes.string.isRequired,
    getSinglePastReport: PropTypes.func.isRequired,
    singlePastReport: PropTypes.object.isRequired,
    getBuData: PropTypes.func.isRequired,
    buData: PropTypes.object.isRequired,
    buDataFetched: PropTypes.bool.isRequired,
    practiceDataCompYr: PropTypes.object.isRequired,
    getComparisonYrPracticeData: PropTypes.func.isRequired,
    projects: PropTypes.object.isRequired,
    projectsFetched: PropTypes.bool.isRequired,
    getDemographics: PropTypes.func.isRequired,
    getBenchmarks: PropTypes.func.isRequired,
    getPracticeResurveyData: PropTypes.func.isRequired,
    getReSurveyData: PropTypes.func.isRequired,
    resetReSurveyDataFetched: PropTypes.func.isRequired,
    reSurveyData: PropTypes.object.isRequired,
    reSurveyDataFetched: PropTypes.bool.isRequired,
    reportsData: PropTypes.array.isRequired,
    getReports: PropTypes.func.isRequired,
    reportsDataFetched: PropTypes.bool.isRequired,
};

export default PracticeBoard;
